/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class CalendarFilter {
    filterHandlers = {
        update: 'calendarFilter/updateFilter',
        reset: 'calendarFilter/resetFilter',
        resetState: 'calendarFilter/resetFilterState',
        removeSelected: 'calendarFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createAutocompleteEntity('specialization');
        filter.setPlaceholder('specialization', 'По специализации');
        filter.setName('specialization', 'search_calendarSpec');
        filter.setPreviewName('specialization', 'Имя');
        filter.setClassName('specialization', 'col-1-row-1');
        filter.setIconClassName('specialization', 'icon-clients');
        filter.setAction('specialization', 'calendarFilter/updateSearch');
        filter.setClearAction('specialization', 'calendarFilter/resetSelect');
        filter.setLoad('specialization', {
            entityName: 'specializations',
            filterName: 'title'
        });

        filter.createAutocompleteEntity('doctor');
        filter.setPlaceholder('doctor', 'По имени');
        filter.setName('doctor', 'search_calendarDoctor');
        filter.setPreviewName('doctor', 'Имя');
        filter.setClassName('doctor', 'col-1-row-2');
        filter.setIconClassName('doctor', 'icon-clients');
        filter.setAction('doctor', 'calendarFilter/updateSearch');
        filter.setClearAction('doctor', 'calendarFilter/resetSelect');
        filter.setLoad('doctor', {
            entityName: 'doctors',
            filterName: 'fullName'
        });
        
        this.filterModel = filter.filterModel;
    }
}
